import {
  TaxInvoiceByOrderIdItems,
  TaxInvoiceItemsOrder,
} from "services/interface";
import { CopyOutlined } from "@ant-design/icons";
import styled from "@emotion/styled";
import { Button, Col, message, Modal, Row, Typography } from "antd";
import React, { Dispatch, FC, SetStateAction, useRef } from "react";
// ใช้ react-copy-to-clipboard แบบ Function Component (แก้ไข TS2786)
// ยกเลิกการใช้ CopyToClipboard ที่ไม่รองรับ JSX (แก้ไข TS2786)

type TaxInvoiceItem = TaxInvoiceItemsOrder | TaxInvoiceByOrderIdItems;

interface ModalTaxInvoiceProps {
  item: TaxInvoiceItem | undefined;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onClose?: () => void;
  // refetchData: () => void;
}

const ModalTaxInvoice: FC<ModalTaxInvoiceProps> = ({ open, setOpen, item }) => {
  const copiedRef = useRef(false);

  const handleCopy = () => {
    copiedRef.current = true;
    message.success("Copied to clipboard");
  };
  const isTaxInvoiceItemsOrder = (
    item: TaxInvoiceItem
  ): item is TaxInvoiceItemsOrder => {
    return (item as TaxInvoiceItemsOrder).taxinvoice_id !== undefined;
  };

  const name = item
    ? isTaxInvoiceItemsOrder(item)
      ? item.taxinvoice_name
      : item.tax_name
    : "";
  const address = item
    ? isTaxInvoiceItemsOrder(item)
      ? item.taxinvoice_address_text
      : item.address_text
    : "";
  const telephone = item
    ? isTaxInvoiceItemsOrder(item)
      ? item.taxinvoice_telephone
      : item.telephone
    : "";
  const taxNumber = item
    ? isTaxInvoiceItemsOrder(item)
      ? item.taxinvoice_no
      : item.tax_no
    : "";

  return (
    <>
      {item && (
        <div>
          <Modal
            title="ข้อมูลใบกำกับภาษี"
            open={open}
            maskClosable={false}
            onCancel={() => {
              setOpen(false);
            }}
            style={{ top: 50 }}
            footer={null}>
            <WrapperAll
              style={{ borderTop: "1px solid #f0f0f0", marginRight: 0 }}>
              <Row style={{ marginTop: 10 }}>
                <Col span={12}>
                  <Typography.Text strong>
                    ชื่อ - สกุล / ชื่อบริษัท
                  </Typography.Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "end",
                  }}>
                  <Typography.Text>
                    {name ?? ""}{" "}
                    {/* ใช้ navigator.clipboard.writeText แทน CopyToClipboard (แก้ไข TS2786) */}
                    <Button
                      size={"small"}
                      onClick={() => {
                        if (name) {
                          navigator.clipboard.writeText(name);
                          message.success("Copied to clipboard");
                        }
                      }}>
                      <CopyOutlined style={{ color: "gray" }} />
                    </Button>
                  </Typography.Text>
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col span={12}>
                  <Typography.Text strong>ที่อยู่</Typography.Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "end",
                  }}>
                  <Typography.Text>
                    {address ?? ""}{" "}
                    <Button
                      size={"small"}
                      onClick={() => {
                        if (address) {
                          navigator.clipboard.writeText(address);
                          message.success("Copied to clipboard");
                        }
                      }}>
                      <CopyOutlined style={{ color: "gray" }} />
                    </Button>
                  </Typography.Text>
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col span={12}>
                  <Typography.Text strong>เบอร์โทรศัพท์</Typography.Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "end",
                  }}>
                  <Typography.Text>
                    {telephone ?? ""}{" "}
                    <Button
                      size={"small"}
                      onClick={() => {
                        if (telephone) {
                          navigator.clipboard.writeText(telephone);
                          message.success("Copied to clipboard");
                        }
                      }}>
                      <CopyOutlined style={{ color: "gray" }} />
                    </Button>
                  </Typography.Text>
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col span={12}>
                  <Typography.Text strong>
                    หมายเลขประจำตัวผู้เสียภาษี
                  </Typography.Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "end",
                  }}>
                  <Typography.Text>
                    {taxNumber ?? ""}{" "}
                    <Button
                      size={"small"}
                      onClick={() => {
                        if (taxNumber) {
                          navigator.clipboard.writeText(taxNumber);
                          message.success("Copied to clipboard");
                        }
                      }}>
                      <CopyOutlined style={{ color: "gray" }} />
                    </Button>
                  </Typography.Text>
                </Col>
              </Row>
            </WrapperAll>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                borderTop: "1px solid #f0f0f0",
                marginRight: 0,
              }}>
              <Button
                style={{ marginTop: "10px" }}
                onClick={() => {
                  setOpen(false);
                }}>
                ปิด
              </Button>
            </div>
          </Modal>
        </div>
      )}
    </>
  );
};

export default ModalTaxInvoice;

const WrapperAll = styled.div`
  padding: 10px 0px 10px 0px;
`;
